import React from "react"

import Link from "./link"

import style from "./nav.module.css"

const Nav = () => (
	<section className={style.topNav}>
		<input id={style.menuToggle} type="checkbox" />
		<label className={style.menuButtonContainer} htmlFor={style.menuToggle}>
			<div className={style.menuButton} />
		</label>
		<ul className={style.menu}>
			<li className={style.entry}>
				<Link to="/talks">Schedule</Link>
			</li>
			<li className={style.entry}>
				<Link to="/trainings">Trainings</Link>
			</li>
			<li className={style.entry}>
				<Link to="/speakers">Speakers</Link>
			</li>
			<li className={style.entry}>
				<Link to="/info">Info</Link>
			</li>
			<li className={style.entry}>
				<Link to="https://accento.dev">Accentos</Link>
			</li>
		</ul>
	</section>
)

export default Nav
